var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-page" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", justify: "", center: "" } },
            [
              _c(
                "v-flex",
                [
                  _vm.error.statusCode === 404
                    ? _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c("v-flex", { staticClass: "py-1" }, [
                            _c("img", {
                              attrs: {
                                src: require("assets/images/404-error.png"),
                                width: "135px"
                              }
                            })
                          ]),
                          _c("v-flex", { staticClass: "py-1" }, [
                            _c("h4", [_vm._v("ERROR 404")])
                          ]),
                          _c("v-flex", [
                            _c("span", [
                              _vm._v("No encontramos la página que "),
                              _c("br"),
                              _vm._v(" estás buscando")
                            ])
                          ]),
                          _c("v-flex", { staticClass: "py-1" }, [
                            _c("h4", [
                              _vm._v("Refresca la página o "),
                              _c("br"),
                              _vm._v(" vuelve al inicio")
                            ])
                          ])
                        ],
                        1
                      )
                    : [
                        _c("v-flex", { staticClass: "ups" }, [
                          _c("h1", [_vm._v("Opss!")]),
                          _c("p", [
                            _vm._v(
                              "Algo salió mal, reintenta o refresca la página."
                            )
                          ])
                        ])
                      ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5435a0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5435a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/error.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a5435a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/error.vue
// module chunks = 34